module.exports = "<div class=\"ui-card card-hoverable padding-md\">\r\n  <div class=\"ui-item margin-sm\">\r\n    <div>\r\n      <small class=\"tag\"><code>{{::$ctrl.data.cheque | lPad: 4: 0}}</code></small>\r\n    </div>\r\n    <div class=\"flex\">\r\n      <b>{{::$ctrl.data.empleado}}</b><br>\r\n      Beneficiario: {{::$ctrl.data.beneficiario}}\r\n    </div>\r\n    <div class=\"flex\"\r\n        align=\"right\">\r\n      <small>Importe</small><br>\r\n      <b>{{::$ctrl.data.importe | currency}}</b>\r\n    </div>\r\n  </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/cheques/components/lista/item/template.html
// module id = 2169
// module chunks = 0